import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import PlanInfo from './plan-info';
import SubscriptionSelector from './subscription-selector';
import { getCustomerId, getSubscriptionInfo, updateSubscription } from 'modules/subscriptions';

class Subscription extends Component {
  static propTypes = {
    billingDueDate: PropTypes.string,
    customerId: PropTypes.string,
    planId: PropTypes.string,
    nextPlanId: PropTypes.string,
    updateSubscription: PropTypes.func.isRequired,
  };

  static defaultProps = {
    planId: 'basic',
    nextPlanId: 'basic',
  };

  state = { mode: 'view' };

  toggleViewMode = () => {
    this.setState(({ mode }) => ({mode: mode === 'view' ? 'edit' : 'view'}));
  };

  saveSubscription = (newPlanId) => {
    if (this.props.nextPlanId !== newPlanId) {
      this.props.updateSubscription(this.props.customerId, newPlanId);
    }
  };

  render() {
    const { mode } = this.state;
    const { customerId } = this.props;

    if (mode === 'view') {
      return (<div>
        <PlanInfo {...this.props} />
        <button type="button"
                onClick={this.toggleViewMode}
                disabled={!customerId}
                className="btn btn-primary">
          Change plan
        </button>
        {!customerId && <p className="small">You need to add credit card before upgrading plan.</p>}
      </div>)
    }
    if (mode === 'edit') {
      return (<div>
        <SubscriptionSelector {...this.props} onCancel={this.toggleViewMode} onSubmit={this.saveSubscription}/>
      </div>)
    }
  }
}

const mapStateToProps = state => {
  return {
    ...getSubscriptionInfo(state),
    customerId: getCustomerId(state),
  };
};

export default connect(mapStateToProps, { updateSubscription })(Subscription);



// WEBPACK FOOTER //
// ./src/components/account/subscription/index.js